var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lion-coin"},[_c('img',{staticClass:"lion-coin__image",attrs:{"src":require('@/assets/lion_coin.png'),"alt":"LoinCoin"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }